import script from "./ActionsButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionsButton.vue?vue&type=script&setup=true&lang=js"

import "./ActionsButton.vue?vue&type=style&index=0&id=36b5cd07&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b5cd07"]])

export default __exports__